/*
| Per-environment settings, baked in at build time from .env.<mode>.
|
| vite.config.js calls readConfig() on the same values, so a missing or wrong
| setting fails the build instead of shipping a bundle that calls nowhere.
*/

const LOOPBACK = /^http:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/;

function url(env, key, problems) {
  const value = String(env[key] ?? '').trim().replace(/\/+$/, '');
  let parsed = null;
  try {
    parsed = new URL(value);
  } catch {
    // reported below
  }
  if (!parsed || !(parsed.protocol === 'https:' || LOOPBACK.test(value))) {
    problems.push(`${key} must be an https URL`);
  }
  return value;
}

function text(env, key, problems) {
  const value = String(env[key] ?? '').trim();
  if (!value) problems.push(`${key} is required`);
  return value;
}

export function readConfig(env) {
  const problems = [];
  const config = {
    apiUrl: url(env, 'VITE_API_URL', problems),
    chainExplorerUrl: url(env, 'VITE_CHAIN_EXPLORER_URL', problems),
    networkName: text(env, 'VITE_NETWORK_NAME', problems),
    networkChain: text(env, 'VITE_NETWORK_CHAIN', problems),
  };

  if (problems.length) {
    throw new Error(`explorer-ui configuration: ${problems.join('; ')}`);
  }

  return config;
}
